<template>
  <div class="opportunity map map-marker">
    <LeaplyMapMarker
      :key="`opportunity-map-marker-${marker.id}`"
      :image="markerImage"
      :small="smallMarker"
      :marker="marker"
      popup
    >
      <div slot="popup" style="border-radius: 2rem;">
        <OpportunityPopup
          v-if="opportunity.id"
          :opportunity="opportunity"
          @apply="$emit('apply', opportunity)"
          :key="`opportunity-popup-${marker.id}`"
        />
      </div>
    </LeaplyMapMarker>
  </div>
</template>

<script>
// Components
import LeaplyMapMarker from '@/components/maps/LeaplyMapMarker'
import OpportunityPopup from '@/components/candidate/opportunities/OpportunityPopup'

// Helpers
import _ from 'lodash'

// Mixins
import { OpportunityMapMarkerImage } from '@/mixins/OpportunityMapMarkerImage.js'

export default {
  name: 'OpportunityMapMarker',

  mixins: [OpportunityMapMarkerImage],

  components: { LeaplyMapMarker, OpportunityPopup },

  props: {
    marker: { type: Object, required: true },
  },

  data() {
    return {
      opportunity: JSON.parse(JSON.stringify(this.marker.opportunity)),
    }
  },

  computed: {
    smallMarker() {
      return this.isOpportunityClosed && !this.eligible
    },
  },
}
</script>

<style lang="scss">
.leaflet-popup {
  .leaflet-popup-content-wrapper {
    .leaflet-popup-content {
      max-width: 30rem;
      width: unset;
    }
  }

  .leaflet-popup-close-button {
    height: 0px;
    display: none;
  }
}
</style>
